<template>
  <main-layout>
    <div class="middle container">
      <!-- <div class="orderby">
        <a
          class="add"
          :href="isLogin ? '/subject/create/step1' : '/login'"
        >{{`+${$t('global.申请创建')} ${(channelId == 1 ? $t('global.高校') : $t('global.学习'))} ${$t('global.频道')}`}}</a>
        <label v-bind:class="{active:orderByType==0}" v-on:click="changeOrder(0)">
          <span class="orderby-icon-time" :class="{'active-time':orderByType==0}"></span>{{$t('global.默认排序')}}
        </label>
        <label v-bind:class="{active:orderByType==1}" v-on:click="changeOrder(1)">
          <span class="orderby-icon-time" :class="{'active-time':orderByType==1}"></span>{{$t('global.最近更新')}}
        </label>
        <label v-bind:class="{active:orderByType==2}" v-on:click="changeOrder(2)">
          <span class="orderby-icon-user" :class="{'active-user':orderByType==2}"></span>{{$t('global.按成员数')}}
        </label>
        <label v-bind:class="{active:orderByType==3}" v-on:click="changeOrder(3)">
          <span class="orderby-icon-vedio" :class="{'active-video':orderByType==3}"></span>{{$t('global.按视频数')}}
        </label>
      </div>
      <div class="subject-list">
        <router-link
          class="subject-item"
          :to="'/subjectdetail/'+item.id"
          v-for="item in videoList"
          :key="item.id"
          target="_blank"
        >
          <img class="subject-img" :src="item.banner | imageUrl('',1110,316)" />
          <div class="subject-content">
            <div class="subject-title" v-if="language!=='zh' && item.enTitle">{{item.enTitle}}</div>
            <div v-else class="subject-title">{{item.title}}</div>
            <div class="subject-summary" style="-webkit-box-orient: vertical;" v-if="language!=='zh' && item.enIntroduction">{{item.enIntroduction}}</div>
            <div class="subject-summary" style="-webkit-box-orient: vertical;" v-else>{{item.introduction}}</div>
            <div class="subject-count">
              <span>
                {{$t('global.视频')}}
                <i>{{item.videoCount || 0}}</i>
              </span>
              <span>
                {{$t('global.成员')}}
                <i>{{item.memberCount}}</i>
              </span>
            </div>
          </div>
        </router-link>
      </div>
      <pages
        :page-size="pagerParam.pageSize"
        :page-count="pagerParam.pageCount"
        :current-page="pagerParam.currentPage"
        :total="pagerParam.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages> -->
      <div class="channelBox">
        <div class="titleBox clearfix">
          <p class="titleName">
            {{ channelId == 1 ? $t("global.高校") : $t("global.学院") }}
          </p>
          <div class="updateChan" @click="updateChannel">
            +
            {{
              channelId == 1
                ? $t("works.创建高校频道")
                : $t("works.创建学习频道")
            }}
          </div>
        </div>
        <div class="typeOrder">
          <span :class="{ active: orderByType == 0 }" @click="changeOrder(0)">{{
            $t("global.默认排序")
          }}</span>
          <span :class="{ active: orderByType == 3 }" @click="changeOrder(3)">{{
            $t("works.最多视频")
          }}</span>
          <span :class="{ active: orderByType == 2 }" @click="changeOrder(2)">{{
            $t("works.最多成员")
          }}</span>
        </div>
        <div class="videoListBox clearfix">
          <router-link
            :to="`/subjectdetail/${item.id}/home?type=1`"
            target="_blank"
            class="videoBox"
            v-for="(item, i) in videoList"
            :key="i"
          >
            <div class="topBox">
              <img :src="item.banner | imageUrl('', 1080, 308)" alt="" />
            </div>
            <div class="botBox">
              <p class="title">
                {{
                  language === "zh" ? item.title : item.enTitle || item.title
                }}
              </p>
              <p class="subTitle">
                {{
                  language === "zh"
                    ? item.introduction
                    : item.enIntroduction || item.introduction
                }}
              </p>
              <p class="number">
                <span>
                  {{ $t("global.视频") }}
                  <i>{{ item.videoCount || 0 }}</i>
                </span>
                <span>
                  {{ $t("global.成员") }}
                  <i>{{ item.memberCount || 0 }}</i>
                </span>
              </p>
            </div>
          </router-link>
        </div>
      </div>
      <pagination
        :pageSize="pagerParam.pageSize"
        :pageIndex="pagerParam.currentPage"
        :totalRecord="pagerParam.total"
        @OnCurrentChanged="OnCurrentPageChanged"
      />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import item from "../../components/item.vue";
import Pagination from "@/components/v2/Pagination";
import FilterTable from "../../components/FilterTable.vue";

export default {
  name: "ExploreSubject",
  metaInfo() {
    return {
      title: this.$t("global.频道") + " | MANA",
    };
  },
  components: {
    MainLayout,
    item,
    Pagination,
    FilterTable,
  },
  data() {
    return {
      selectedFilters: [],
      filterList: [],
      industryId: "",
      professionId: "",
      orderByType: 0,
      videoList: [],
      isLogin: localStorage.getItem("auth_token") !== null,
      pagerParam: {
        pageSize: 12,
        pageCount: 1,
        currentPage: 1,
        total: 1,
      },
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  created() {
    this.channelId = this.$route.params.type;
    this.filterList = [
      {
        name: this.$t("global.行 业"),
        list: [],
      },
      {
        name: this.$t("global.专 业"),
        list: [],
      },
    ];
    this.$http.get("/api/common/categoryList").then((response) => {
      if (response.data.industryList) {
        for (var i = 0; i < response.data.industryList.length; i++) {
          this.filterList[0].list.push({
            name: response.data.industryList[i]["title"],
            value: response.data.industryList[i]["categoryId"],
            cat: 1,
          });
        }
      }
      if (response.data.professionList) {
        for (var i = 0; i < response.data.professionList.length; i++) {
          this.filterList[1].list.push({
            name: response.data.professionList[i]["title"],
            value: response.data.professionList[i]["categoryId"],
            cat: 2,
          });
        }
      }
    });
    this.GetVideoList();
    this.buriedPoint(31,0)
  },
  methods: {
    updateChannel() {
      if (this.isLogin) {
        this.$router.push("/subject/create/step1");
      } else {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
      }
    },
    changeOrder(val) {
      this.pagerParam.currentPage = 1;
      this.orderByType = val;
    },
    GoToSubjectDetail(id) {
      this.$router.push("/subjectdetail/" + id);
    },
    GetVideoList() {
      let pageSize = this.pagerParam.pageSize;
      this.$http
        .get(
          "/api/topic/findList?industryId=" +
            this.industryId +
            "&professionId=" +
            this.professionId +
            "&orderByType=" +
            this.orderByType +
            "&pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            pageSize +
            "&type=" +
            this.channelId
        )
        .then((response) => {
          if (response.data) {
            this.videoList = response.data.list;
            this.pagerParam.pageCount = response.data.totalPage;
            this.pagerParam.currentPage = response.data.pageIndex;
            this.pagerParam.total = response.data.totalRecord;
          }
        });
    },
    FilterChanged() {
      this.industryId = "";
      this.professionId = "";
      this.pagerParam.currentPage = 1;
      for (var i = 0; i < this.selectedFilters.length; i++) {
        if (this.selectedFilters[i].cat == 1) {
          this.industryId = this.selectedFilters[i].value;
        } else if (this.selectedFilters[i].cat == 2) {
          this.professionId = this.selectedFilters[i].value;
        }
      }
      this.$forceUpdate();
      this.GetVideoList();
    },
    GotoUrl(url) {
      this.$router.push(url);
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.GetVideoList();
    },
    deleteFilter(index) {
      this.selectedFilters.splice(index, 1);
      this.FilterChanged();
    },
  },
  watch: {
    orderByType: function () {
      this.GetVideoList();
    },
    "$route.params.type": function (val) {
      this.channelId = val;
      this.GetVideoList();
    },
  },
};
</script>

<style scoped>
.top {
  padding-top: 0.6rem;
}
.top-filter {
  color: #000;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  overflow: hidden;
  zoom: 1;
  background: #fff;
}
.top-tabs {
  width: 140px;
  float: left;
  font-size: 0.26rem;
}
.top-tab {
  height: 0.87rem;
  line-height: 0.87rem;
  text-align: center;
  background-color: #fbfbfb;
  cursor: pointer;
  color: #999;
}
.top-tab.active {
  background-color: #fff;
  color: #333333;
}
.top-tab-contents {
  width: 1020px;
  float: left;
}
.filter-result {
  margin-top: 0.2rem;
  text-align: center;
}
.filter-result .pre {
  margin-right: 0.4rem;
}
.filter-result .el-button {
  color: #0060ff;
  border-color: #dcdfe6 !important;
}
.filter-result .el-button-group {
  margin-right: 0.2rem;
}
.orderby {
  margin: 40px 0 20px;
  line-height: 0.16rem;
  color: #777777;
  font-size: 0.16rem;
}
.orderby .add {
  float: right;
  color: #0060ff;
}
.orderby > label {
  display: inline-block;
  margin-right: 0.3rem;
}
.orderby .active {
  color: #0060ff;
}
.orderby label {
  cursor: pointer;
}
.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
}
.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.16rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.vedio-list .el-row {
  margin: 0 -0.13rem;
}
.vedio-list .item {
  margin: 0.13rem;
  cursor: pointer;
}
.author-item {
  overflow: hidden;
  zoom: 1;
  border-bottom: 1px solid #dddddd;
  padding: 0.4rem 0;
}
.author-info {
  float: left;
  width: 7.46rem;
  overflow: hidden;
  zoom: 1;
}
.author-avatar {
  width: 1.3rem;
  height: 1.3rem;
  float: left;
  display: block;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.author-content {
  width: 6.13rem;
  float: left;
  padding-left: 0.3rem;
  padding-top: 0.07rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.author-name {
  font-size: 0.26rem;
  color: #333333;
}
.author-title {
  font-size: 0.16rem;
  color: #777777;
  margin: 0.1rem 0 0.2rem;
}
.author-focus {
  display: block;
  width: 1.2rem;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  background-color: #0060ff;
  -webkit-border-radius: 0.2rem;
  -moz-border-radius: 0.2rem;
  border-radius: 0.2rem;
}
.author-vedio {
  float: right;
  width: 8.6rem;
  margin: 0.07rem -0.05rem 0;
  overflow: hidden;
  zoom: 1;
  position: relative;
}
.author-vedio-item {
  width: 25%;
  float: left;
  padding: 0 0.05rem;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.author-vedio-item img {
  width: 2.06rem;
  height: 1.16rem;
  display: block;
  margin: 0 auto;
}
.orderby-icon-user {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url("/static/explore/user.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby-icon-vedio {
  display: inline-block;
  width: 0.16rem;
  height: 0.17rem;
  background: url("/static/explore/vediocount.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  font-size: 0.26rem;
}
.orderby .active-time {
  background: url("/static/explore/focusTime.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-user {
  background: url("/static/explore/focusUser.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-video {
  background: url("/static/explore/focusVideo.png") no-repeat center center;
  background-size: contain;
}
.subject-list {
  margin: 0 auto;
  overflow: hidden;
  zoom: 1;
}
.subject-item {
  cursor: pointer;
  display: block;
  float: left;
  width: 565px;
  margin: 0 30px 30px 0;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 2px 2px 2px #eaeaea;
  -moz-box-shadow: 2px 2px 2px #eaeaea;
  box-shadow: 2px 2px 2px #eaeaea;
}

.subject-item:nth-child(2n) {
  margin-right: 0;
}
.subject-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
  padding: 0;
}
.subject-add:before {
  content: "";
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 7.8rem;
  height: 100px;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.subject-add:after {
  content: "";
  display: block;
  width: 0.8rem;
  height: 0.8rem;
  background: url("/static/explore/add.png") no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 1.5rem;
  top: 1.5rem;
}
.subject-img {
  display: block;
  height: 161px;
  width: 565px;
}
.subject-content {
  padding: 20px;
}
.subject-title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.subject-summary {
  height: 40px;
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  word-break: break-word;
}
.subject-count {
  margin-top: 15px;
  font-size: 12px;
  color: #999;
}
.subject-count span {
  margin-right: 10px;
}
.subject-count span i {
  color: #333;
}
</style>
<style lang="stylus" scoped>
.channelBox {
  width: 1110px;
  margin: 0 auto;
  padding-top: 68px;

  .titleBox {
    height: 66px;

    .titleName {
      float: left;
      height: 66px;
      font-size: 44px;
      font-weight: 600;
      color: #000000;
      line-height: 66px;
    }

    .updateChan {
      float: right;
      padding: 0 36px;
      height: 40px;
      background: #1C21B0;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 13px;
      cursor: pointer;
    }
  }

  .typeOrder {
    margin: 32px 0 30px 0;

    span {
      margin-right: 30px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      cursor: pointer;

      &:hover {
        color: #2026CC;
      }
    }

    .active {
      font-weight: 600;
      color: #0A0A0A;
    }
  }

  .videoListBox {
    .videoBox {
      float: left;
      width: 538px;
      height: 300px;
      border: 1px solid #EBEBEB;
      margin-right: 30px;
      margin-bottom: 40px;

      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
      }

      &:nth-child(2n) {
        margin-right: 0;
      }

      .topBox {
        width: 538px;
        height: 154px;
        position: relative;

        img {
          position: absolute;
          width: 538px;
          height: 154px;
          top: 0;
          left: 0;
        }
      }

      .botBox {
        padding: 16px 15px 0;

        .title {
          height: 30px;
          font-size: 20px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .subTitle {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
          height: 40px;
          font-size: 13px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          margin: 8px 0 16px 0;
        }

        .number {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;

          span {
            margin-right: 20px;

            i {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/explore/channel.vue